import Vue from '../../node_modules/vue/dist/vue.esm'

Vue.options.delimiters = ['<{', '}>']
export default Vue
